import React from 'react';
export const RadioButton = (props) => {
    const { onChange } = props;

    const radio = props.data.map((value, index) =>
        <div key={"key" + index}>
            <input
                type="radio"
                id={props.id + index}
                name={props.name}
                className={props.inputClassName}
                defaultChecked={value.checked}
                value={value.value}
                onChange={onChange}
                disabled={props.disabled} />
            <label htmlFor={props.id + index} className={props.labelClassName}>{value.text}</label>
        </div>
    );
    return (
        <div style={props.style}>
            {radio}
        </div>
    );
}
